import { Grid } from '@mui/material';
import React from 'react';
import Radio from './Radio';

const RadioButtonGroup = ({value, options, onChange, perRows, radioStyle, containerStyle, small, id, disabled=false  }) => {
    return (
        <div style={{ display : 'flex', justifyContent : 'space-between',...containerStyle}}>
            <Grid container direction={'row'}  alignItems="center" columns={16}>
                {
                    options.map((data,i) => {
                        return(
                            //perRows로 column 갯수 조절
                            <Grid xs={(16/perRows)} item key={i}>
                                <Radio id={`${id + i}`} value={data.value} checked={value === data.value} label={data.label} onChange={onChange} radioStyle={radioStyle} small={small} disabled={disabled}/>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </div>
    )
}

export default RadioButtonGroup;